<template>
  <div class="my-order" ref="container">
    <div class="header bg-color-red">
      <div class="picTxt acea-row row-between-wrapper">
        <div class="text">
          <div class="name">售后单信息</div>
          <!-- <div>累计订单：0 总消费：￥ 0</div> -->
        </div>
        <div class="pictrue">
          <img src="@assets/images/orderTime.png" />
        </div>
      </div>
    </div>
    <div class="nav acea-row row-around">
      <!-- <div class="item" :class="{ on: type === 2 }" @click="changeType(2)">
        <div>未受理</div>
        <div class="num">{{statistics.no}}</div>
      </div> -->
      <div class="item" :class="{ on: type === 1 }" @click="changeType(1)">
        <div>受理中</div>
        <div class="num">{{ statistics.ship }}</div>
      </div>
      <div class="item" :class="{ on: type === 2 }" @click="changeType(2)">
        <div>已受理</div>
        <div class="num">{{ statistics.complete }}</div>
      </div>
    </div>
    <div class="list">
      <div class="item" v-for="(item, index) in orderList" :key="index">
        <div class="title acea-row row-between-wrapper">
          <div class="row-middle">
            <p>{{ item.sn }}</p>
            <p class="order-date">{{ formdate(item.create_time) }}</p>
          </div>
          <div class="font-color-red">{{ status[item.status] }}</div>
        </div>
        <div>
          <div class="item-info acea-row row-between row-top">
            <div class="text acea-row row-between">
              <p class="name">
                {{ item.consignee_name }}
                <span class="marginL20">{{ item.consignee_phone }}</span>
              </p>
              <p>{{ item.consignee_address }}</p>
            </div>
          </div>
        </div>
        <div class="totalPrice">
          共{{ item.total_spu }}件商品，数量{{ item.total_num }}，总金额
          <span class="money font-color-red">￥{{ item.total_price }}</span>
        </div>
        <div class="bottom acea-row row-right row-middle">
          <template>
            <div class="bnt bg-color-red" @click="goDetail('serviceOrderDetail',item.id, 0)">
              查看详情
            </div>
            <div
              class="bnt bg-color-red"
              @click="goDetail('serviceOrderConfirm', item.id, 1)"
            >
              确认详情
            </div>
          </template>
        </div>
      </div>
    </div>
    <div class="noCart" v-if="orderList.length === 0 && page > 1">
      <div class="pictrue">
        <img src="@assets/images/noOrder.png" />
      </div>
    </div>
    <Loading :loaded="loaded" :loading="loading"></Loading>
    <Payment
      v-model="pay"
      :types="payType"
      @checked="toPay"
      :balance="userInfo.now_money"
    ></Payment>
    <GeneralWindow
      :generalActive="generalActive"
      @closeGeneralWindow="closeGeneralWindow"
      :generalContent="generalContent"
    ></GeneralWindow>
  </div>
</template>
<script>
import { getServiceList, getServiceStatistics } from "@api/order";
import Loading from "@components/Loading";
import Payment from "@components/Payment";
import { mapGetters } from "vuex";
import { isWeixin } from "@utils";
import GeneralWindow from "@components/GeneralWindow";
const NAME = "serviceOrder";

export default {
  name: NAME,
  data() {
    return {
      offlinePayStatus: 2,
      orderData: {},
      type: parseInt(this.$route.params.type) || 1,
      page: 1,
      limit: 20,
      loaded: false,
      loading: false,
      orderList: [],
      status: {
        "0": "受理中",
        "1": "已受理"
        // '2': '未受理'
      },
      pay: false,
      limitTime: 0,
      generalActive: false,
      generalContent: {
        promoterNum: "",
        title: ""
      },
      statistics: {
        has: 0,
        no: 0,
        wait: 0
      }
    };
  },
  components: {
    Loading,
    Payment,
    GeneralWindow
  },
  computed: mapGetters(["userInfo"]),
  created() {
    this.getOrderStatistics();
  },
  watch: {
    $route(n) {
      if (n.name === NAME) {
        const type = parseInt(this.$route.params.type) || 0;
        if (this.type !== type) {
          this.changeType(type);
        }
        // this.getOrderData();
      }
    }
  },
  methods: {
    getOrderStatistics() {
      getServiceStatistics()
        .then(res => {
          console.log(res);
          this.statistics = res.data;
        })
        .catch(e => {
          console.log(e);
          if (e.msg == "ok") {
            this.statistics = e.data.data;
          }
        });
    },
    getOrderList() {
      if (this.loading || this.loaded) return;
      this.loading = true;
      const { page, limit, limitTime } = this;
      getServiceList({
        page,
        limit,
        limitTime,
        orderAfterStatus: this.type
      }).then(res => {
        this.orderList = this.orderList.concat(res.data.data);
        this.limitTime = res.data.limitTime;
        this.page++;
        this.loaded = res.data.data.length < this.limit;
        this.loading = false;
      });
    },
    goDetail(val, id, isShow) {
      this.$router.push({
        path: "/myOrder/" + val,
        query: {
          orderAfterId: id,
          isShow: isShow
        }
      });
    },
    formdate(date) {
      var unixTimestamp = new Date(date * 1000);
      var commonTime = unixTimestamp.toLocaleString();
      var s = commonTime.toLocaleString();
      var ss = s.replace(/年|月/g, "-").replace(/日/g, " ");
      return ss;
    },
    closeGeneralWindow(msg) {
      this.generalActive = msg;
      this.reload();
      this.getOrderData();
    },
    reload() {
      this.changeType(this.type);
    },
    changeType(type) {
      this.type = type;
      this.orderList = [];
      this.page = 1;
      this.loaded = false;
      this.loading = false;
      this.getOrderList();
    },
    getStatus(order) {
      return STATUS[order._status._type];
    },
    paymentTap: function(order) {
      var that = this;
      if (
        !(
          order.combination_id > 0 ||
          order.bargain_id > 0 ||
          order.seckill_id > 0
        )
      ) {
        that.setOfflinePayStatus(order.offlinePayStatus);
      }
      this.pay = true;
      this.toPay = type => {
        payOrderHandle(order.order_id, type, that.from)
          .then(() => {
            const type = parseInt(this.$route.params.type) || 0;
            that.changeType(type);
            that.getOrderData();
          })
          .catch(res => {
            if (res.status === "WECHAT_H5_PAY")
              return that.$router.push({
                path: "/order/status/" + order.order_id + "/5"
              });
            const type = parseInt(that.$route.params.type) || 0;
            that.changeType(type);
            that.getOrderData();
          });
      };
    },
    toPay() {}
  },
  mounted() {
    // this.getOrderData();
    this.getOrderList();
    this.$scroll(this.$refs.container, () => {
      !this.loading && this.getOrderList();
    });
  }
};
</script>

<style scoped>
.noCart {
  margin-top: 0.17rem;
  padding-top: 0.1rem;
}

.noCart .pictrue {
  width: 4rem;
  height: 3rem;
  margin: 0.7rem auto 0.5rem auto;
}

.noCart .pictrue img {
  width: 100%;
  height: 100%;
}

.marginL20 {
  margin-left: 0.4rem;
}
.order-date {
  font-size: 0.2rem;
  color: #999;
}
</style>
